var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var OutsourceSettlevOucherService = /** @class */ (function () {
    function OutsourceSettlevOucherService() {
    }
    /**
     *  委外结算单列表
     */
    OutsourceSettlevOucherService.prototype.getCaseSettlementSheetPageList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceSettleIndexManageController.getCaseSettlementSheetPageList,
            data: {
                outBatch: data.outBatch,
                delegateDate: FilterService.dateRanageFormat(data.date).start,
                endDate: FilterService.dateRanageFormat(data.date).end,
                outId: data.outsName
            },
            page: page,
            sort: sort,
        });
    };
    /**
     *  委外结算单明细列表
     */
    OutsourceSettlevOucherService.prototype.getSettlementSheetDetailPageList = function (data) {
        return this.netService.send({
            server: domainService.outsourceSettleIndexManageController.getSettlementSheetDetailPageList,
            data: data
        });
    };
    /**
     *  导出对账单
     */
    OutsourceSettlevOucherService.prototype.exportSettlementSheet = function (data) {
        return this.netService.send({
            server: domainService.outsourceSettleIndexManageController.exportSettlementSheet,
            data: data
        });
    };
    /**
     *  导出对账单明细
     */
    OutsourceSettlevOucherService.prototype.exportSettlementSheetDetail = function (data) {
        return this.netService.send({
            server: domainService.outsourceSettleIndexManageController.exportSettlementSheetDetail,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceSettlevOucherService.prototype, "netService", void 0);
    return OutsourceSettlevOucherService;
}());
export { OutsourceSettlevOucherService };
